import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import ActionCallsView from '../Integrations/ApiCallsView';

const sampleNoData = {
  uid: '1',
  dataReady: true,
  interval_grouping: 'day',
  noDataFoundMessage: 'There are no API calls made.',
  period_start: '2018-10-01T00:00:00Z',
  period_end: '2018-10-31T00:00:00Z',
  period_selected: false,
  status: 'success',
  periods: [],
  usage: [],
};

const sampleFullAPICalls = {
  uid: '1',
  dataReady: true,
  interval_grouping: 'day',
  noDataFoundMessage: 'There are no API calls made.',
  period_start: '2018-10-01T00:00:00Z',
  period_end: '2018-10-31T00:00:00Z',
  period_selected: true,
  status: 'success',
  periods: [
    {
      api_calls: 21,
      end: '2018-08-31T00:00:00Z',
      start: '2018-08-01T00:00:00Z',
      title: 'Dropbox',
      total_cost: 21,
    },
    {
      api_calls: 13,
      end: '2018-09-30T00:00:00Z',
      start: '2018-09-01T00:00:00Z',
      title: 'Dropbox',
      total_cost: 13,
    },
    {
      api_calls: 10,
      end: '2018-10-31T00:00:00Z',
      start: '2018-10-01T00:00:00Z',
      title: 'Dropbox',
      total_cost: 10,
    },
  ],
  usage: [
    {
      calls: 20,
      description: '20 Document API Calls Synced to Dropbox',
      interval: '2018-10-03T00:00:00Z',
      service: 'dropbox',
      service_name: 'Dropbox',
      type: 'files',
    },
    {
      calls: 3,
      description: '3 Document API Calls Synced to Dropbox',
      interval: '2018-10-04T00:00:00Z',
      service: 'dropbox',
      service_name: 'Dropbox',
      type: 'files',
    },
    {
      calls: 2,
      description: '2 Document API Calls Synced to Dropbox',
      interval: '2018-10-05T00:00:00Z',
      service: 'dropbox',
      service_name: 'Dropbox',
      type: 'files',
    },
    {
      calls: 2,
      description: '2 Document API Calls Synced to Dropbox',
      interval: '2018-10-06T00:00:00Z',
      service: 'dropbox',
      service_name: 'Dropbox',
      type: 'files',
    },
    {
      calls: 1,
      description: '1 Document API Calls Synced to Dropbox',
      interval: '2018-10-07T00:00:00Z',
      service: 'dropbox',
      service_name: 'Dropbox',
      type: 'files',
    },
    {
      calls: 1,
      description: '1 Document API Calls Synced to Dropbox',
      interval: '2018-10-08T00:00:00Z',
      service: 'dropbox',
      service_name: 'Dropbox',
      type: 'files',
    },
  ],
};


storiesOf('Integrations', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch periods data</h3>
      <hr />
      <ActionCallsView loadingBar/>
    </div>
  ))
  .add('ApiCalls', () => (
    <div>
      <h3>By default, we display <b>Details tab</b> which contains details of billing periods</h3>
      <h4>Clicking the <b>Summary tab</b> should bring up Summary table </h4>
      <hr />

      <ActionCallsView
        {...sampleFullAPICalls}
        />
    </div>
  ))
  .add('ApiCalls - no data', () => (
    <div>
      <h3>When there is no data display message no data found
      </h3>
      <hr />
      <ActionCallsView
        {...sampleNoData} />
    </div>
  ));




/** WEBPACK FOOTER **
 ** ./src/Integrations/ApiCalls.stories.jsx
 **/